<template>
  <div class="c-salesforce-proxy-connection-fields">
    <BittsInput
      ref="input"
      v-model="proxyUrl"
      name="salesforce-proxy-url"
      data-testid="salesforce-proxy-url"
      form-label="Proxy URL"
      placeholder="https://sf-proxy.acme.com"
      :status="statusOf('proxyUrl')"
      :danger-text="errors.proxyUrl"
      :disabled="isDisabled"
      @blur="emit('blur', 'proxyUrl')"
    />
    <BittsInput
      v-model="clientId"
      name="salesforce-client-id"
      data-testid="salesforce-client-id"
      form-label="Client ID"
      :status="statusOf('clientId')"
      :danger-text="errors.clientId"
      :disabled="isDisabled"
      @blur="emit('blur', 'clientId')"
    />
    <BittsInput
      v-model="clientSecret"
      type="password"
      autocomplete="new-password"
      name="salesforce-client-secret"
      data-testid="salesforce-client-secret"
      form-label="Client Secret"
      :placeholder="clientSecretPlaceholder"
      :status="statusOf('clientSecret')"
      :danger-text="errors.clientSecret"
      :disabled="isDisabled"
      @blur="emit('blur', 'clientSecret')"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsInput } from '@crossbeam/bitts';

import { useTemplateRef } from 'vue';

import type { SalesforceProxyFieldType } from '@/composables/useSalesforceProxyConnection';

const props = defineProps<{
  errors: Partial<Record<SalesforceProxyFieldType, string>>;
  isDisabled?: boolean;
  clientSecretPlaceholder?: string;
}>();

const emit = defineEmits<{ blur: [field: SalesforceProxyFieldType] }>();

const proxyUrl = defineModel<string>('proxyUrl', { required: true });
const clientId = defineModel<string>('clientId', { required: true });
const clientSecret = defineModel<string>('clientSecret', { required: true });

const input = useTemplateRef<InstanceType<typeof BittsInput>>('input');

function statusOf(field: SalesforceProxyFieldType): 'danger' | undefined {
  return props.errors[field] ? 'danger' : undefined;
}

function focus() {
  input.value?.focusInput();
}

defineExpose({ focus });
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.c-salesforce-proxy-connection-fields {
  @apply flex w-full flex-col gap-12 text-left;
}
</style>
